import React from 'react';
import FormInboxNav from 'components/FormInbox/FormInboxNav';
import FormInboxList from 'components/FormInbox/FormInboxList';
import PropTypes from 'prop-types';
import { getMetaContent } from 'utils';

/**
 * Renders the react portion of the Form Inbox page.
 *
 * This includes the view navigation and the form list for the "drafts" view only. The other views "default" and
 * "imported" have not been ported to react yet.
 *
 * @param view the form inbox view
 * @param userType indicates parent or admin view for the "drafts" view
 * @returns {JSX.Element}
 */
const FormInbox = ({ view, userType }) => {
  return <React.Fragment>
    <FormInboxNav view={view} userType={userType}/>

    {/* The drafts view uses the jquery/haml bulk actions which require a form with a CSRF token */}
    {view === 'drafts' && <form id="forms_list_view" method="post">
      <input
        type="hidden"
        name={getMetaContent('csrf-param')}
        value={getMetaContent('csrf-token')}
      />

      <FormInboxList view={view} userType={userType}/>
    </form>}
  </React.Fragment>;
};

FormInbox.propTypes = {
  userType: PropTypes.oneOf(['admin', 'parent']),
  view: PropTypes.oneOf(['default', 'drafts', 'imported']),
};

export default FormInbox;
